/* eslint-disable react/prop-types */
import React from 'react'
import { useOutletContext } from 'react-router-dom'
import SecretKeySection from './SecretKeySection'
import ApiSection from './ApiSection'

export function CredentialsSection() {
  const { verificationListing } = useOutletContext()

  return (
    <div>
      <SecretKeySection listing={verificationListing} />
      <ApiSection listing={verificationListing} />
    </div>
  )
}

export default CredentialsSection
